import { Action, createAction, props } from '@ngrx/store';
import { InvitationDto, TentativePermissionRequestDto } from '@careapp-group/ng-sdk-v2-new';

export const REQUEST_INVITATION_SEND = '[Invite][Request] Send Invitation';
export const REQUEST_INVITATION_RESET = '[Invite][Request] Reset Invitation';
export const REQUEST_INVITATION_UPLOAD = '[Invite][Request] Upload CSV';
export const REQUEST_INVITATIONS_PENDING = '[Invite][Request] list pending';
export const REQUEST_SEARCH_ALL_PENDING_INVITATIONS_ADMIN =
  '[Invite][Request] Search all pending invitations (Admin)';
export const RESPONSE_SUCCESS_INVITATION_SEND = '[Invite][Response][Success] Send Invitation';
export const RESPONSE_FAIL_INVITATION_SEND = '[Invite][Response][Fail] Send Invitation';
export const RESPONSE_SUCCESS_INVITATION_UPLOAD = '[Invite][Response][Success] Upload CSV';
export const RESPONSE_FAIL_INVITATION_UPLOAD = '[Invite][Response][Fail] Upload CSV';
export const RESPONSE_SUCCESS_INVITATIONS_PENDING = '[Invite][Response][Success] list pending';
export const RESPONSE_FAIL_INVITATIONS_PENDING = '[Invite][Response][FAIL] list pending';
export const RESPONSE_SUCCESS_SEARCH_ALL_PENDING_INVITATIONS_ADMIN =
  '[Invite][Response][Success] Search all pending invitations (Admin)';
export const RESPONSE_FAIL_SEARCH_ALL_PENDING_INVITATIONS_ADMIN =
  '[Invite][Response][Fail] Search all pending invitations (Admin)';

export const REQUEST_INVITATION_RESEND = '[Invite][Request] Resend Invitation';
export const RESPONSE_SUCCESS_INVITATION_RESEND = '[Invite][Response][Success] Resend Invitation';
export const RESPONSE_FAIL_INVITATION_RESEND = '[Invite][Response][Fail] Resend Invitation';

export const REQUEST_INVITATION_CANCEL = '[Invite][Request] Cancel Invitation';
export const RESPONSE_SUCCESS_INVITATION_CANCEL = '[Invite][Response][Success] Cancel Invitation';
export const RESPONSE_FAIL_INVITATION_CANCEL = '[Invite][Response][Fail] Cancel Invitation';

export class RequestInvitationSendAction implements Action {
  readonly type = REQUEST_INVITATION_SEND;
  constructor(
    public payload: {
      email: string;
      role: string;
      externalId?: string;
      permissions?: TentativePermissionRequestDto[];
      accessAllCustomers?: boolean;
      modelName?: 'Organisation' | 'Tenant';
    }
  ) {}
}

export class RequestSearchPendingInvitationsAdmin implements Action {
  readonly type = REQUEST_SEARCH_ALL_PENDING_INVITATIONS_ADMIN;
  constructor(public payload: { query: string }) {}
}
export class ResponseSuccessSearchPendingInvitationsAdmin implements Action {
  readonly type = RESPONSE_SUCCESS_SEARCH_ALL_PENDING_INVITATIONS_ADMIN;
  constructor(public payload: InvitationDto[]) {}
}
export class ResponseFailSearchPendingInvitationsAdmin implements Action {
  readonly type = RESPONSE_FAIL_SEARCH_ALL_PENDING_INVITATIONS_ADMIN;
  constructor(public payload: any) {}
}

// If an organisationId is not passed in, use the currently selected organisation ID.
export class RequestInvitationResendAction implements Action {
  readonly type = REQUEST_INVITATION_RESEND;
  constructor(public payload: { id: string; organisationId?: string }) {}
}
// If an organisationId is not passed in, use the currently selected organisation ID.
export class RequestInvitationCancelAction implements Action {
  readonly type = REQUEST_INVITATION_CANCEL;
  constructor(public payload: { id: string; organisationId?: string }) {}
}

export class RequestInvitationResetAction implements Action {
  readonly type = REQUEST_INVITATION_RESET;
}

export class RequestPendingInvitations implements Action {
  readonly type = REQUEST_INVITATIONS_PENDING;
  constructor(public payload?: { modelName?: 'Tenant' | 'Organisation' }) {}
}
export class ResponseSuccessInvitationResendAction implements Action {
  readonly type = RESPONSE_SUCCESS_INVITATION_RESEND;
  constructor(public payload: any) {}
}
export class ResponseFailInvitationResendAction implements Action {
  readonly type = RESPONSE_FAIL_INVITATION_RESEND;
  constructor(public invite: any, public error: any) {}
}

export class ResponseSuccessPendingInvitations implements Action {
  readonly type = RESPONSE_SUCCESS_INVITATIONS_PENDING;
  constructor(public payload: InvitationDto[]) {}
}

export class ResponseFailPendingInvitations implements Action {
  readonly type = RESPONSE_FAIL_INVITATIONS_PENDING;
  constructor(public payload: any) {}
}

export class ResponseSuccessInvitationSendAction implements Action {
  readonly type = RESPONSE_SUCCESS_INVITATION_SEND;
  constructor(public payload: any) {}
}
export class ResponseSuccessInvitationCancelAction implements Action {
  readonly type = RESPONSE_SUCCESS_INVITATION_CANCEL;
  constructor(public payload: any) {}
}

export class ResponseFailInvitationSendAction implements Action {
  readonly type = RESPONSE_FAIL_INVITATION_SEND;
  constructor(public payload: any) {}
}

export class RequestInvitationUploadAction implements Action {
  readonly type = REQUEST_INVITATION_UPLOAD;
  constructor(public payload: any) {}
}

export class ResponseSuccessInvitationUploadAction implements Action {
  readonly type = RESPONSE_SUCCESS_INVITATION_UPLOAD;
  constructor(public payload: any) {}
}

export class ResponseFailInvitationUploadAction implements Action {
  readonly type = RESPONSE_FAIL_INVITATION_UPLOAD;
  constructor(public payload: any) {}
}

export class ResponseFailInvitationResend implements Action {
  readonly type = RESPONSE_FAIL_INVITATION_RESEND;
  constructor(public payload: any) {}
}
export class ResponseFailInvitationCancel implements Action {
  readonly type = RESPONSE_FAIL_INVITATION_CANCEL;
  constructor(public payload: any) {}
}

export const RequestInviteWithToken = createAction(
  '[Invite][Request] Get Invite',
  props<{ token: string }>()
);
export const SuccessInviteWithToken = createAction(
  '[Invite][Response][Success] Get Invite',
  props<{ payload: InvitationDto }>()
);

export const FailInviteWithToken = createAction(
  '[Invite][Response][Fail] Get Invite',
  props<{ error: any }>()
);

export const RequestAcceptInvite = createAction(
  '[Invite][Request] Accept Invite',
  props<{ token: string }>()
);
export const SuccessAcceptInvite = createAction('[Invite][Response][Success] Accept Invite');

export const FailAcceptInvite = createAction(
  '[Invite][Response][Fail] Accept Invite',
  props<{ error: any }>()
);
